import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './index.css'
import VueShowdown from 'vue-showdown'


// import { rtdbPlugin } from 'vuefire'
// Vue.use(rtdbPlugin)

Vue.config.productionTip = false
Vue.use(VueShowdown)
// Vue.prototype.$Ammo = window.Ammo

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
